import { api } from "../lib/api";
import { h, mount } from "../ui/dom";
import { key } from "../ui/widgets";

export function mountSignin(root: HTMLElement, onDone: () => void): void {
  const input = h("input", { type: "password", autocomplete: "off", spellcheck: false, "aria-label": "Access code", id: "code" });
  const err = h("div", { class: "err", role: "alert" });
  const go = async () => {
    if (!input.value.trim()) return;
    err.textContent = "";
    enter.disabled = true;
    try {
      await api.signIn(input.value.trim());
      onDone();
    } catch (e) {
      err.textContent = ((e as Error).message || "That didn't work.").toUpperCase();
      enter.disabled = false;
      input.select();
    }
  };
  const enter = key("ENTER", () => void go(), { primary: true });
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") void go();
  });
  mount(
    root,
    h(
      "div",
      { class: "signin" },
      h(
        "div",
        { class: "panel" },
        h("div", { class: "brand", style: "margin-bottom:18px" }, h("b", null, "RADAR")),
        h("label", { class: "f" }, h("span", { class: "micro" }, "ACCESS CODE"), input),
        err,
        h("div", { class: "row", style: "margin:10px 0 16px" }, enter),
        h("p", { class: "help", style: "margin:0" }, "Private workspace. Files are encrypted at rest and only this workspace can read them."),
      ),
    ),
  );
  input.focus();
}
